import React from 'react'
import { useSelector } from 'react-redux'
import style from '../../chatModule/chatscreen.module.scss'
import * as timeago from 'timeago.js'

const MessageBubble = ({ message }) => {
  const me = useSelector((state) => state.app.me)
  const isMessageByDoctor = Boolean(me.id === message.fromID)
  const isMessageImage = Boolean(message.type === 'image')
  const handleCopyClick = (imageUrl) => {
    navigator.clipboard.writeText(imageUrl)
    // eslint-disable-next-line no-undef
    alert('Image URL copied to clipboard!')
  }


  if (isMessageByDoctor) {
    return (
      <div>
        <div className={style.time}>
          {
            isMessageImage ? <div>
              {' '}
              <img
                id="image"
                src={message.content}
                className={style.imageSize}
                alt="logo"
              />
              <button
                className={style.copylink}
                onClick={() => handleCopyClick(message.content)}
              >
                Copy link
              </button>
            </div> : <div className={style.doctorMsg}>
              {message.content}

            </div>
          }

          <span className={style.doctorTimestamp}>
                    {timeago.format(message.timestamp)}

        </span>

          <br />
        </div>

      </div>

    )

  }

  return (
    <div>
      <div className={style.UserTime}>
       <span className={style.userMsg}>
      {message.content}
    </span>
        <span className={style.userTimestamp}>
                    {timeago.format(message.timestamp)}

        </span>

        <br />
      </div>

    </div>

  )
}
export default MessageBubble
